// Description: This component render a Modal when the user do something 
// Update: 17/01/2024

// React Components and DOM Elements
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

// Material UI Components
import { Box, styled, Button, Dialog } from '@mui/material';

// Components and functions from the project
import Titles from '../Titles/Titles';
import themeColors from '../ThemeColors/ThemeColors';
import { isAuthenticated } from '../../authMiddleware';
import StatusIcon from '../StatusLabel/StatusIcon';
import MessageIcon from './messageIcon.png';
import DynamicButton from '../DynamicButton/DynamicButton';
import use123zapStore from '../../context/123zapStore';

// Customizating the Dialog Component
const CustomDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiPaper-root': {
        borderRadius: "12px",
        width: "461px",
        height: "427px",
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        maxWidth: "500px !important",
    },
    '& .MuiDialog-container': {
        height: "100vh",
        width: "100vw",
        position: "fixed",
        top: "0",
        left: "0",
        display: "block",
    },
}));

// Render Your Component
function CampaignModal({ isOpen, onClose, onConfirm, title, subTitle, confirmText, cancelText, iconColor, onCancel, iconButton, iconButtonClose }) {
    // Authentication Context Functions
    const { authenticated } = isAuthenticated();
    const navigate = useNavigate();

    // State variables
    const userInfo = use123zapStore((state) => state.userInfo);
    const setUserInfo = use123zapStore((state) => state.setUserInfo);

    // Effect to fetch the user info
    useEffect(() => {
        if (authenticated) {
            const { decryptedData } = isAuthenticated();
            setUserInfo(decryptedData);
        } else {
            navigate("/login");
        }
    }, []);

    const closeModal = () => {
        onClose(false);
    };

    return (
        <CustomDialog
            open={isOpen}
            onClose={onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            maxWidth={false}
            onBackdropClick={closeModal}
        >
            <Box padding={"40px"} paddingTop={"60px"} sx={{ textAlign: "center", backgroundColor: "#fff" }}>
                <Box
                    display={"flex"}
                    sx={{ justifyContent: "center", marginBottom: "10px", gap: "10px" }}
                >
                    <StatusIcon color={'#A986FF'} status={'emoji02'} height={'84px'} width={'84px'} />
                    <Box component='img' src={MessageIcon} height={'87px'} width={'87px'} />
                    <StatusIcon color={iconColor} status={'emoji13'} height={'84px'} width={'84px'} />
                </Box>

                <Box display={"flex"} sx={{ flexDirection: "column", gap: "10px", marginBottom: "20px", marginTop: "20px" }}>
                    <Titles font={"Satoshi"} children={title} color={themeColors.purple600} styles={{ fontSize: { xs: '18px', sm: '24px' }, fontWeight: 500 }} />

                    <Titles font={"Satoshi"} children={subTitle} color={themeColors.gray50} styles={{ fontSize: { xs: '13px', sm: '16px' } }} />
                </Box>

                <Box display={"flex"} sx={{ flexDirection: "column", gap: "5px" }}>
                    <Button sx={{
                        backgroundColor: "transparent",
                        border: `2px solid ${themeColors.purple400}`,
                        color: themeColors.purple500,
                        padding: "9px",
                        borderRadius: "6px",
                        width: "100%",
                    }} onClick={onCancel}
                        startIcon={iconButtonClose}
                    >
                        {cancelText}
                    </Button>
                    {confirmText && (
                        <DynamicButton
                            text={confirmText}
                            handleFunction={onConfirm}
                            style={{
                                backgroundColor: themeColors.purple500,
                                color: "white",
                                padding: "9px",
                                borderRadius: "6px",
                                border: "none",
                                width: "100%",
                                '&:hover': {
                                    backgroundColor: themeColors.purple400
                                },
                            }}
                        />
                    )}
                </Box>
            </Box>
        </CustomDialog>
    );
}

export default CampaignModal